<div class="d-flex justify-content-between align-item-center instanceDataHeader" *ngIf="!isCustomScreen">
    <div class="instanceHeader">
        <h2 *ngIf="!demoMode" mat-dialog-title class="dialog-title">
            <span class="mr-1" [textContent]="name"></span>
            <mat-icon class="mr-2 ml-2">double_arrow</mat-icon>
            <span class="-pl-1">
                <span [textContent]="'Run #' + clearanceRunNumber"></span>
                <ng-container *ngIf="(stateName | async)?.length > 0">
                    <span [textContent]="'/ ' + (stateName | async)"></span>
                </ng-container>
            </span>
            <mat-icon class="mr-2 ml-2">double_arrow</mat-icon>
            <span class="mr-1" [textContent]="nonDetachedEntity?.displayName"></span>
        </h2>
        <h2 *ngIf="demoMode" mat-dialog-title class="dialog-title">
            Selected records of entity:
            <strong [textContent]="nonDetachedEntity?.displayName"></strong>
        </h2>
    </div>
    <div class="loadingContainer" *ngIf="!demoMode && (workflowLoadingState || (loadingStatus | async))">
        <app-dots-loader [showLoading]="true"></app-dots-loader>
    </div>
    <mat-icon (click)="closeModal()">close</mat-icon>
</div>
<mat-dialog-content [ngClass]="{ 'demo-mat-dialog-content': demoMode, 'block !h-[calc(100%-50px)]': isCustomScreen }">
    <div class="dialog-main-container">
        <ng-container *ngIf="!demoMode">
            <app-instance-data-primary-entity></app-instance-data-primary-entity>
        </ng-container>
        <div class="row body-container">
            <div class="left-menu" *ngIf="!demoMode">
                <div class="entitiesListContainer">
                    <div class="entitiesListMainContainer">
                        <ng-container *ngIf="reconConfiguration?.groups?.length > 0 || nonReconEntities?.length > 0">
                            <ng-container *ngFor="let group of reconConfiguration?.groups">
                                <div *ngIf="!group?.grouped">
                                    <div
                                         class="entityListItemContainer"
                                         [ngClass]="{ '!pl-[15px]': isCustomScreen }"
                                         [class.pointer-events-none]="workflowLoadingState || (loadingStatus | async)"
                                         stop-propagation
                                         (click)="selectGroup(group)">
                                        <mat-icon
                                                  class="entityItemIcon material-icons-outlined normalIcon"
                                                  [class.activeEntity]="isReconEntity && selectedGroup?.id === group?.id">
                                            check_circle_outline
                                        </mat-icon>
                                        <span
                                              class="entityItemName"
                                              [class.activeEntity]="isReconEntity && selectedGroup?.id === group?.id"
                                              [title]="group?.description || group?.name"
                                              matTooltipClass="custom-tooltip">
                                            <span [textContent]="group?.name"></span>
                                        </span>
                                    </div>
                                </div>
                                <div *ngIf="group?.grouped">
                                    <div class="flex cursor-pointer" (click)="toggleGroup(group)">
                                        <mat-icon class="inline-block mr-[3px]">
                                            {{ group.expanded ? 'arrow_drop_down' : 'arrow_right' }}
                                        </mat-icon>
                                        <span class="groupItemName" [title]="group?.name" matTooltipClass="custom-tooltip">
                                            <span [textContent]="group?.name"></span>
                                        </span>
                                    </div>
                                    <ng-container *ngIf="group.expanded">
                                        <ng-container *ngFor="let childGroup of group.childGroup">
                                            <div
                                                 class="entityListItemContainer !pl-[22px]"
                                                 [ngClass]="{ '!pl-[15px]': isCustomScreen }"
                                                 [class.pointer-events-none]="workflowLoadingState || (loadingStatus | async)"
                                                 stop-propagation
                                                 (click)="selectGroup(childGroup)">
                                                <mat-icon
                                                          class="entityItemIcon material-icons-outlined normalIcon"
                                                          [class.activeEntity]="isReconEntity && selectedGroup?.id === childGroup?.id">
                                                    check_circle_outline
                                                </mat-icon>
                                                <span
                                                      class="entityItemName"
                                                      [class.activeEntity]="isReconEntity && selectedGroup?.id === childGroup?.id"
                                                      [title]="childGroup?.description || childGroup?.name"
                                                      matTooltipClass="custom-tooltip">
                                                    <span [textContent]="childGroup?.name"></span>
                                                </span>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </ng-container>
                            <div class="nonReconEntities">
                                <app-instance-data-entities
                                                            [entities]="nonReconEntities"
                                                            [supportsRecon]="true"
                                                            [isCustomScreen]="isCustomScreen"
                                                            (onEntitySelect)="onNonReconEntitySelect()"></app-instance-data-entities>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="right-content" *transloco="let translate">

                <div class="instance-data-content row !ml-[15px] !mr-0">
                    <div
                         class="source col-6 primary"
                         [class.nonReconEntity]="!isReconEntity"
                         *ngIf="isConfigurationLoaded || !isReconEntity">
                        <div class="sourceHeader">
                            <div class="flex items-center gap-7">
                                <div
                                     class="sourceText"
                                     *ngIf="isReconEntity"
                                     [textContent]="(source1Details?.name || source1) + ' : ' + aggregationcardinalityCountForSource1"></div>

                                <!-- Export Dropdown -->
                                <button *ngIf="isDetached" mat-stroked-button [matMenuTriggerFor]="exportMenuSource1">
                                    <mat-icon>download</mat-icon>
                                    Export
                                    <mat-icon>arrow_drop_down</mat-icon>
                                </button>

                                <mat-menu #exportMenuSource1="matMenu" xPosition="before">
                                    <button mat-menu-item (click)="exportTableData('source1', 'selected')">
                                        <mat-icon>download</mat-icon>
                                        <span>Export Selected Items</span>
                                    </button>

                                    <button mat-menu-item (click)="exportTableData('source1', 'all')">
                                        <mat-icon>download</mat-icon>
                                        <span>Export All Items</span>
                                    </button>
                                </mat-menu>
                            </div>
                            <div class="flex items-center gap-4">
                                <div class="w-[35%]">
                                    <mat-form-field class="font-bold">
                                        <mat-label *ngIf="!selectedTable1Id" class="!font-bold !text-black">
                                            {{ translate('Select Column for Total') }}
                                        </mat-label>
                                        <mat-select
                                                    [(value)]="selectedTable1Id"
                                                    (selectionChange)="onSelectedColumnChange('source1', $event.value)"
                                                    [title]="selectedTable1Id || ''">
                                            <mat-option [value]="null">
                                                <em>
                                                    --
                                                    <span [textContent]="translate('Please select')"></span>
                                                    --
                                                </em>
                                            </mat-option>
                                            <mat-option *ngFor="let table of table1NumericFields" [value]="table.id">
                                                {{ table.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <span
                                      class="sourceText !relative left-[10px]"
                                      [textContent]="translate('Total') + ' : ' + table1_totalCount"></span>
                            </div>
                        </div>
                        <app-gst-instance-data-table
                                                     [debounce]="1000"
                                                     [demoMode]="demoMode"
                                                     [isMisMatchGroup]="isReconEntity && isDetached"
                                                     [canSelectMultiple]="isReconEntity && reconConfiguration?.restapiname?.length > 0"
                                                     [templateId]="'source1'"
                                                     [data]="source1tableData"
                                                     [allTableColumns]="source1_allColumns"
                                                     [selectedColumns]="source1_selectedColumns"
                                                     [columnSearchRequired]="!demoMode && true"
                                                     (clickedRecord)="clickedRecord($event)"
                                                     (onSearchEvent)="onColumnSearch($event, isDetached ? 'source1' : undefined)"
                                                     (onColumnChange)="onColumnChangeFromTable($event)"
                                                     [aggregationsTemplate]="aggregationsTemplate"
                                                     [useUserPreferences]="true"
                                                     (onResetPreferences)="resetColumnPreferences('source1')"></app-gst-instance-data-table>
                        <mat-paginator
                                       *ngIf="isReconEntity && isDetached"
                                       [hidden]="demoMode || source1Pagination?.index === undefined || !isConfigurationLoaded || !isDetached"
                                       [pageIndex]="source1Pagination.index"
                                       [pageSizeOptions]="[5, 10, 20, 50]"
                                       [length]="source1Pagination.count"
                                       [pageSize]="source1Pagination.size"
                                       showFirstLastButtons="false"
                                       (page)="changedPage($event, 'source1')"></mat-paginator>
                        <ng-template #aggregationsTemplate let-column="column">
                            <aggregations-menu
                                               [isFromClearance]="isReconEntity"
                                               [searchableIndexFields]="source1SearchableField"
                                               [column]="column"
                                               [entity]="!isReconEntity ? selectedEntity : isDetached ? detachedSource1Entity : nonDetachedEntity"
                                               [reconCriteria]="reconCriteriaSource1"
                                               [instanceId]="instanceId"
                                               [clearAggregationData]="clearAggregationData"
                                               [serviceId]="serviceId"
                                               [restApiName]="app?.restApiName"></aggregations-menu>
                        </ng-template>
                    </div>
                    <div class="source col-6 secondary last" *ngIf="isConfigurationLoaded && isReconEntity">
                        <div class="sourceHeader">
                            <div class="flex items-center gap-7">
                                <div
                                     class="sourceText"
                                     [textContent]="(source2Details?.name || source2) + ': ' + aggregationcardinalityCountForSource2"></div>

                                <!-- Export Dropdown -->
                                <button *ngIf="isDetached" mat-stroked-button [matMenuTriggerFor]="exportMenuSource2">
                                    <mat-icon>download</mat-icon>
                                    Export
                                    <mat-icon>arrow_drop_down</mat-icon>
                                </button>

                                <mat-menu #exportMenuSource2="matMenu" xPosition="before">
                                    <button mat-menu-item (click)="exportTableData('source2', 'selected')">
                                        <mat-icon>download</mat-icon>
                                        <span>Export Selected Items</span>
                                    </button>

                                    <button mat-menu-item (click)="exportTableData('source2', 'all')">
                                        <mat-icon>download</mat-icon>
                                        <span>Export All Items</span>
                                    </button>
                                </mat-menu>
                            </div>
                            <div class="flex items-center gap-4">
                                <div class="w-[30%]">
                                    <mat-form-field class="font-bold">
                                        <mat-label *ngIf="!selectedTable2Id" class="!font-bold !text-black">
                                            {{ translate('Select Column for Total') }}
                                        </mat-label>
                                        <mat-select
                                                    [(value)]="selectedTable2Id"
                                                    (selectionChange)="onSelectedColumnChange('source2', $event.value)"
                                                    [title]="selectedTable2Id || ''">
                                            <mat-option [value]="null">
                                                <em>
                                                    --
                                                    <span [textContent]="translate('Please select')"></span>
                                                    --
                                                </em>
                                            </mat-option>
                                            <mat-option *ngFor="let table of table2NumericFields" [value]="table.id">
                                                {{ table.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <span
                                      class="sourceText !relative left-[10px]"
                                      [textContent]="translate('Total') + ' : ' + table2_totalCount"></span>

                                <div *ngIf="isReconEntity">
                                    <span
                                          class="sourceText !relative left-[10px]"
                                          [textContent]="translate('Variance') + ' : ' + variance_totalCount"></span>
                                </div>
                            </div>
                        </div>
                        <app-gst-instance-data-table
                                                     [debounce]="1000"
                                                     [demoMode]="demoMode"
                                                     [isMisMatchGroup]="isDetached"
                                                     [canSelectMultiple]="reconConfiguration?.restapiname?.length > 0"
                                                     [templateId]="'source2'"
                                                     [data]="source2tableData"
                                                     [allTableColumns]="source2_allColumns"
                                                     [selectedColumns]="source2_selectedColumns"
                                                     [columnSearchRequired]="!demoMode && true"
                                                     (clickedRecord)="clickedRecord($event)"
                                                     (onSearchEvent)="onColumnSearch($event, isDetached ? 'source2' : undefined)"
                                                     (onColumnChange)="onColumnChangeFromTable($event)"
                                                     [aggregationsTemplate]="aggregationsTemplate"
                                                     [useUserPreferences]="true"
                                                     (onResetPreferences)="resetColumnPreferences('source2')"></app-gst-instance-data-table>
                        <mat-paginator
                                       *ngIf="isDetached"
                                       [hidden]="demoMode || source2Pagination?.index === undefined || !isConfigurationLoaded || !isDetached"
                                       [pageIndex]="source2Pagination.index"
                                       [pageSizeOptions]="[5, 10, 20, 50]"
                                       [length]="source2Pagination.count"
                                       [pageSize]="source2Pagination.size"
                                       showFirstLastButtons="false"
                                       (page)="changedPage($event, 'source2')"></mat-paginator>
                        <ng-template #aggregationsTemplate let-column="column">
                            <aggregations-menu
                                               [isFromClearance]="isReconEntity"
                                               [searchableIndexFields]="source2SearchableField"
                                               [column]="column"
                                               [entity]="!isReconEntity ? selectedEntity : isDetached ? detachedSource2Entity : nonDetachedEntity"
                                               [reconCriteria]="reconCriteriaSource2"
                                               [instanceId]="instanceId"
                                               [clearAggregationData]="clearAggregationData"
                                               [serviceId]="serviceId"
                                               [restApiName]="app?.restApiName"></aggregations-menu>
                        </ng-template>
                    </div>
                    <mat-paginator
                                   class="pt-[45px] !border-none"
                                   *ngIf="!isDetached || !isReconEntity"
                                   [hidden]="demoMode || source1Pagination?.index === undefined || !isConfigurationLoaded"
                                   [pageIndex]="source1Pagination.index"
                                   [pageSizeOptions]="[5, 10, 20, 50, 100, 500]"
                                   [length]="dataLength"
                                   [pageSize]="source1Pagination.size"
                                   showFirstLastButtons="false"
                                   (page)="changedPage($event)"></mat-paginator>
                </div>
            </div>
            <div class="entityActionsContainer" [hidden]="demoMode" *transloco="let translate">
                <material-button
                                 [hidden]="isCustomScreen"
                                 [color]="'warning'"
                                 [text]="'Show Selected'"
                                 (buttonClicked)="showSelectedRecords()"></material-button>
                <ng-container *ngIf="workflowActions?.length > 0">
                    <ng-container *ngTemplateOutlet="workflowActions?.length > 1 ? actionsTemplate : actionTemplate"></ng-container>
                </ng-container>
                <material-button
                                 [text]="'Proceed'"
                                 *ngIf="workflowActions?.length > 1"
                                 [disabled]="selectedWorkflowAction === undefined || selectedWorkflowAction?.name?.length === 0"
                                 (buttonClicked)="initiateWorkFlowAction()"></material-button>
            </div>
        </div>
    </div>
</mat-dialog-content>

<ng-template #actionsTemplate>
    <div class="workflowActions">
        <material-button
                         [buttonType]="'raised'"
                         [text]="selectedWorkflowAction?.name || 'Take Action'"
                         [matMenuTriggerFor]="menu"
                         [disabled]="selectedRecordsCount === 0 || workflowLoadingState || (loadingStatus | async)"
                         [suffixIcon]="'arrow_drop_down'"
                         [suffixIconType]="'material'"></material-button>

        <mat-menu #menu="matMenu" class="filingWorkflowActionsContainer !bg-white" xPosition="before">
            <div *ngFor="let action of workflowActions">
                <material-button [text]="action.name" (buttonClicked)="selectedWorkflowAction = action"></material-button>
            </div>
        </mat-menu>
    </div>
</ng-template>

<ng-template #actionTemplate>
    <material-button
                     [text]="workflowActions?.[0]?.name || 'Proceed'"
                     (buttonClicked)="selectedWorkflowAction = workflowActions?.[0]; initiateWorkFlowAction()"
                     [disabled]="demoMode || selectedRecordsCount === 0 || workflowLoadingState || (loadingStatus | async)"></material-button>
</ng-template>
